import { render, staticRenderFns } from "./SearchReportTaskQueue.vue?vue&type=template&id=641f6ee9&scoped=true&"
import script from "./SearchReportTaskQueue.vue?vue&type=script&lang=js&"
export * from "./SearchReportTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./SearchReportTaskQueue.vue?vue&type=style&index=0&id=641f6ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f6ee9",
  null
  
)

export default component.exports